<template>
  <div id="numbers-blacklist-list" class="numbers-blacklist-list-container">
    <vs-table
      ref="table"
      noDataText="Sem dados disponíveis"
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="numbersBlacklist"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center" />

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4"
        >
          <div
            class="
              p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg
              cursor-pointer flex items-center justify-between font-medium
            "
          >
            <span class="mr-2">
              {{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                    numbersBlacklist.length - currentPage * itemsPerPage > 0
                    ? currentPage * itemsPerPage
                    : numbersBlacklist.length
              }} of {{ queriedItems }}
            </span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="customer-name">Contato</vs-th>
        <vs-th sort-key="customer-phone-number">Número</vs-th>
        <vs-th sort-key="customer-phone-number">
          Bloqueio Automático
          <vx-tooltip
            text="Data e hora em que este número entrará definitivamente 
                      na lista de números bloqueados para receber mensagens via WhatsApp"
            color="primary"
            position="top"
          >
            <feather-icon
              icon="InfoIcon"
              svgClasses="ml-1 w-5 h-5 hover:text-primary stroke-current"
            />
          </vx-tooltip>
        </vs-th>
        <vs-th sort-key="customer-phone-number">Status Atual</vs-th>
        <vs-th colspan="2">Ações</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-email font-medium truncate">
                {{ tr.customer.name }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-email font-medium truncate">
                {{ tr.customer.phone_number }}
              </p>
            </vs-td>

            <vs-td>
              <p class="product-email font-medium">
                {{ tr.wait_until }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip :color="getNumberStatusColor(tr.blacklisted_at)" class="product-order-status">
                {{ getNumberStatusName(tr.blacklisted_at) }}
              </vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vx-tooltip
                v-if="canSee('block')"
                text="Bloquear número"
                color="primary"
                position="top"
              >
                <feather-icon
                  icon="SlashIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="blockNumber(tr.id)"
                  v-if="!tr.blacklisted_at"
                />
              </vx-tooltip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <vx-tooltip
                v-if="canSee('unblock')"
                text="Desbloquear número"
                color="primary"
                position="top"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  @click.stop="deleteData(tr.id)"
                  v-if="!tr.blacklisted_at"
                />
              </vx-tooltip>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
  import moduleNumberBlacklist from '@/store/numberBlacklist/moduleNumberBlacklist'
  import { hasPermission } from '@/utils'

  export default {
    name: 'numbers-blacklist-list',
    data() {
      return {
        selected: [],
        itemsPerPage: 4,
        isMounted: false,
      }
    },
    computed: {
      currentPage() {
        if (this.isMounted) {
          return this.$refs.table.currentx
        }

        return 0
      },
      numbersBlacklist() {
        return this.$store.state.numberBlacklist.numbersBlacklist
      },
      queriedItems() {
        return this.$refs.table ? this.$refs.table.queriedResults.length : this.numbersBlacklist.length
      }
    },
    methods: {
      getNumberStatusName(blacklistedAt) {
        if (blacklistedAt === null || blacklistedAt === 'null' || blacklistedAt === "") {
          return 'Aguardando'
        }

        const blacklistedAtDate = blacklistedAt.split(" ")

        return `Bloqueado em ${blacklistedAtDate[0]}`
      },
      getNumberStatusColor(blacklistedAt) {
        if (blacklistedAt === null || blacklistedAt === 'null' || blacklistedAt === "") {
          return 'warning'
        }

        return 'dark'
      },
      deleteData(numberBlacklistId) {
        this.$store.dispatch("numberBlacklist/delete", numberBlacklistId).catch(err => { console.error(err) })
      },
      blockNumber(numberBlacklistId) {
        this.$store.dispatch("numberBlacklist/block", numberBlacklistId).catch(err => { console.error(err) })
      },
      canSee(action) {
        return hasPermission(`${this.$route.name}-${action}`)
      }
    },
    created() {
      if (!moduleNumberBlacklist.isRegistered) {
        this.$store.registerModule('numberBlacklist', moduleNumberBlacklist)
        moduleNumberBlacklist.isRegistered = true
      }
      this.$store.dispatch("numberBlacklist/fetch")
    },
    mounted() {
      this.isMounted = true;
    }
  }
</script>

<style lang="scss">
  #numbers-blacklist-list {
    .vs-con-table {
      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
        margin-left: 1.5rem;
        margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }

      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        padding: 0 1rem;


        tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 10px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
            &.img-container {
              // width: 1rem;
              // background: #fff;

              span {
                display: flex;
                justify-content: flex-start;
              }

              .product-img {
                height: 110px;
              }
            }
          }
          td.td-check{
            padding: 20px !important;
          }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;

          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
    }
  }
</style>
